import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { PrivateOrganizationInfoReportListResponse } from '@/types/api/mypage/privateOrganizationInfoReportList';

/** 任意団体活動報告書一覧取得APIのURL */
const url = ApiUrl.Read.PRIVATE_ORGANIZATION_INFO_REPORT_LIST;

/**
 * 任意団体活動報告書一覧取得APIの呼び出しフック。
 * 月次帳票の選択肢一覧を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetPrivateOrganizationInfoReportList = () => {
  const execute = useCallback(async (): Promise<
    AxiosResponse<PrivateOrganizationInfoReportListResponse>
  > => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetPrivateOrganizationInfoReportList;
